class HealthInsurancePriceRequest {
  years1 = 0;
  years2 = 0;
  fromage = 0;
  toage = 0;
  companyid = null;

  createdby = null;
  updatedby = null;
}
export default HealthInsurancePriceRequest;
